"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("underscore");

var _colors = require("./../helpers/colors");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function BaseSVGAlignment(props) {
  var sequence_data = props.sequence_data,
      site_size = props.site_size;
  if (!sequence_data) return /*#__PURE__*/_react["default"].createElement("g", null);
  var site_color = props.amino_acid ? _colors.amino_acid_color : props.site_color,
      text_color = props.amino_acid ? _colors.amino_acid_text_color : props.text_color;
  var characters = (0, _underscore.flatten)(sequence_data.map(function (sequence, i) {
    return sequence.seq.split("").map(function (character, j) {
      var x = site_size * j,
          y = site_size * i,
          half_site_size = site_size / 2,
          g_translate = "translate(".concat(x, ", ").concat(y, ")"),
          text_translate = "translate(".concat(half_site_size, ", ").concat(half_site_size, ")");
      return /*#__PURE__*/_react["default"].createElement("g", {
        transform: g_translate,
        key: [i, j]
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: 0,
        y: 0,
        width: site_size + 1,
        height: site_size + 1,
        fill: site_color(character, j, sequence.header)
      }), /*#__PURE__*/_react["default"].createElement("text", {
        transform: text_translate,
        fill: text_color(character),
        textAnchor: "middle",
        dy: ".25em"
      }, props.molecule(character, j, sequence.header)));
    });
  }));
  return /*#__PURE__*/_react["default"].createElement("g", {
    style: {
      width: site_size * sequence_data[0].seq.length,
      height: site_size * sequence_data.length,
      fontFamily: "Courier"
    },
    transform: "translate(".concat(props.translateX, ",").concat(props.translateY, ")")
  }, characters);
}

BaseSVGAlignment.defaultProps = {
  site_color: _colors.nucleotide_color,
  text_color: _colors.nucleotide_text_color,
  molecule: function molecule(mol) {
    return mol;
  },
  site_size: 20,
  translateX: 0,
  translateY: 0
};
var _default = BaseSVGAlignment;
exports["default"] = _default;